export const TOOL_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "tool.flashlight_aa_basic", name: "FIELD FLASHLIGHT", shortName: "FLASHLIGHT",
        description: "A compact neutral-white LED field light powered by two AA cells. Fixed focused beam.",
        category: "TOOL", tags: ["TOOL", "ELECTRONIC", "METAL"], stackLimit: 1,
        unitMassGrams: 85, volumeMl: 80, longestDimensionMm: 115,
        iconKey: "flashlight", worldAssetId: "flashlight_basic", scarcity: "COMMON", sortOrder: 73,
        lightDevice: { emitterType: "LED", luminousFluxLumens: 120, colorTemperatureKelvin: 4800,
            beamAngleDegrees: 26, beamSoftness: 0.35, effectiveRangeMeters: 36, powerDrawWatts: 0.45,
            battery: { format: "AA", count: 2 }, adjustableFocus: false },
    },
    {
        id: "tool.screwdriver_flat",
        name: "FLAT SCREWDRIVER",
        description: "A flat-head driver with a worn insulated handle.",
        category: "TOOL",
        tags: ["TOOL", "METAL"],
        stackLimit: 1,
        unitMassGrams: 180,
        volumeMl: 90,
        longestDimensionMm: 185,
        iconKey: "tool",
        worldAssetId: "small_tool",
        conditionModel: "DURABILITY",
        durabilityMax: 100,
        scarcity: "COMMON",
        sortOrder: 70,
    },
    {
        id: "tool.pliers",
        name: "PLIERS",
        description: "Steel combination pliers with surface corrosion.",
        category: "TOOL",
        tags: ["TOOL", "METAL"],
        stackLimit: 1,
        unitMassGrams: 260,
        volumeMl: 140,
        longestDimensionMm: 165,
        iconKey: "tool",
        worldAssetId: "small_tool",
        conditionModel: "DURABILITY",
        durabilityMax: 100,
        scarcity: "COMMON",
        sortOrder: 71,
    },
    {
        id: "tool.small_wrench",
        name: "SMALL WRENCH",
        description: "A compact open-ended steel wrench.",
        category: "TOOL",
        tags: ["TOOL", "METAL"],
        stackLimit: 1,
        unitMassGrams: 310,
        volumeMl: 115,
        longestDimensionMm: 150,
        iconKey: "tool",
        worldAssetId: "small_tool",
        conditionModel: "DURABILITY",
        durabilityMax: 100,
        scarcity: "COMMON",
        sortOrder: 72,
    },
]);
